import { defineStore } from 'pinia'
import i18n from '@/i18n'
import api from '@/api/api'

const SUPPORTED = ['pl','en','es','it','ar','ja','ko','nl','pt','zh']
const LS_KEY = 'preferred_locale'

function setI18nLocale(lang) {
    const g = i18n?.global || i18n
    if (g?.locale && typeof g.locale === 'object' && 'value' in g.locale) g.locale.value = lang // v9
    else if (g?.locale) g.locale = lang // v8
    else if (i18n?.locale) i18n.locale = lang
    if (typeof document !== 'undefined') document.documentElement.setAttribute('lang', lang)
}

function applyHttpLanguage(lang) {
    if (api?.defaults?.headers?.common) {
        api.defaults.headers.common['Accept-Language'] = lang
        api.defaults.headers.common['X-Lang'] = lang // opcjonalnie
    }
}

export const useLocaleStore = defineStore('locale', {
    state: () => ({ lang: 'pl' }),
    actions: {
        init() {
            const saved = typeof window !== 'undefined' ? localStorage.getItem(LS_KEY) : null
            const initial = (saved && SUPPORTED.includes(saved)) ? saved : this.lang
            this.lang = initial
            setI18nLocale(initial)
            applyHttpLanguage(initial)
        },
        set(lang) {
            if (!SUPPORTED.includes(lang)) return
            this.lang = lang
            if (typeof window !== 'undefined') localStorage.setItem(LS_KEY, lang)
            setI18nLocale(lang)
            applyHttpLanguage(lang)
        },
        get() { return this.lang }
    }
})
